import $ from 'jquery';

const deferred = {};

export default class AsyncView {
  static load(url, view, sha256 = false, settingsSha256 = false) {
    let data;
    if (url in deferred) {
      return deferred[url];
    }

    const $deferred = $.Deferred();

    deferred[url] = $deferred;

    if (sha256) {
      data = sessionStorage.getItem(url);

      if (data) {
        const deserialized = JSON.parse(data);

        if (
          (sha256 === deserialized.options.sha256)
          && (!settingsSha256 || settingsSha256 === deserialized.options.settings_sha256)
        ) {
          delete deferred[url];

          return $deferred.resolve(deserialized).promise();
        }
      }
    }

    $.ajax({
      url,
      data: `view=${view}`,
      dataType: 'html',
      success: (response) => {
        const el = document.createElement('div');
        el.innerHTML = response;

        const options = JSON.parse(el.querySelector('[data-options]').innerHTML);
        const htmls = el.querySelectorAll('[data-html]');

        let html = {};

        if (htmls.length === 1 && htmls[0].getAttribute('data-html') === '') {
          html = htmls[0].innerHTML;
        } else {
          for (let i = 0; i < htmls.length; i++) {
            html[htmls[i].getAttribute('data-html')] = htmls[i].innerHTML;
          }
        }

        if (sha256) {
          try {
            sessionStorage.setItem(
              url,
              JSON.stringify({ options, html }),
            );
          } catch (error) {
            console.error(error);
          }
        }

        delete deferred[url];
        return $deferred.resolve({ options, html });
      },
      error: () => {
        delete deferred[url];
        return $deferred.reject();
      }
      ,
    });

    return $deferred.promise();
  }
}
